import { render, staticRenderFns } from "./ProductInventoryMinPerOrder.vue?vue&type=template&id=b22cc46e&"
import script from "./ProductInventoryMinPerOrder.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryMinPerOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports